import type { FormSegment } from '../types.ts';
import { isSegmentExpired, isSegmentSoonToExpire } from './hasExpiredSegments.ts';

const getExpirationRank = (segment: FormSegment): number => {
  if (isSegmentExpired(segment)) return 0;
  if (isSegmentSoonToExpire(segment)) return 1;
  return 2;
};

/**
 * Orders segments for display: expired first, then soon to expire, then the rest.
 * The sort is stable, so the original order is kept within each group, and the input is not mutated.
 */
export const sortSegmentsByExpiration = <T extends FormSegment>(segments: T[]): T[] =>
  segments
    .map(segment => ({ segment, rank: getExpirationRank(segment) }))
    .sort((a, b) => a.rank - b.rank)
    .map(({ segment }) => segment);
